"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function appendBuffer(buffer1, buffer2) {
    const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(new Uint8Array(buffer1), 0);
    tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
    return tmp.buffer;
}
exports.appendBuffer = appendBuffer;
//# sourceMappingURL=misc.js.map